<app-navbar></app-navbar>
<div class="container mt-3">
  <router-outlet></router-outlet>
</div>
